











































import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-swatch-filter'
})

export default class extends Vue {
  @Prop() readonly dataSource: string;
  @Prop() readonly filter!: object;

  readonly filtersToShow: number = 8;
  readonly smallBreakpoint: number = 768;
  private filterCollapsed: boolean = this.filter['options'].length > this.filtersToShow;
  private filterOpen: boolean = window.outerWidth >= this.smallBreakpoint;

  toggleFilterValueCollapse(): void {
    this.filterCollapsed = !this.filterCollapsed;
  }

  filterIsVisibleCheck(index): boolean {
    return this.filterCollapsed ? index < this.filtersToShow : true;
  }

  optionWhite(o): boolean {
    return ['#ffffff', '#fff'].includes(o.color_code.toLowerCase()) || o.label.toLowerCase().includes('wit') || o.label.toLowerCase().includes('white')
  }

  toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

}
